import {omneticApi} from '@dms/api/base';

import {
  GetUserCredentialApiArg,
  GetUserCredentialApiResponse,
  ListUserCredentialsApiArg,
  ListUserCredentialsApiResponse,
  SetUserCredentialApiArg,
  SetUserCredentialApiResponse,
  SetMyCredentialApiArg,
  ListMyCredentialsApiArg,
  ListMyCredentialsApiResponse,
} from './types';

export const generalSettingsApi = omneticApi.injectEndpoints({
  endpoints: (build) => ({
    getUserCredential: build.query<GetUserCredentialApiResponse, GetUserCredentialApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/user/${queryArg.userId}/external-credential/${queryArg.integratedServiceType}`,
        params: {authorizationProfileId: queryArg.authorizationProfileId},
      }),
    }),
    setUserCredential: build.mutation<SetUserCredentialApiResponse, SetUserCredentialApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/user/${queryArg.userId}/external-credential/${queryArg.integratedServiceType}`,
        method: 'POST',
        body: queryArg.credentialRequestBody,
      }),
    }),
    setMyCredential: build.mutation<SetUserCredentialApiResponse, SetMyCredentialApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/user/external-credential/${queryArg.integratedServiceType}`,
        method: 'POST',
        body: queryArg.credentialRequestBody,
      }),
    }),
    listUserCredentials: build.query<ListUserCredentialsApiResponse, ListUserCredentialsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/user/${queryArg.userId}/external-credentials`,
        params: queryArg.params,
      }),
    }),
    listMyCredentials: build.query<ListMyCredentialsApiResponse, ListMyCredentialsApiArg>({
      query: (queryArg) => ({
        url: `/dms/v1/user/external-credentials`,
        params: queryArg.params,
      }),
    }),
  }),
});

export const {
  useGetUserCredentialQuery,
  useSetMyCredentialMutation,
  useListUserCredentialsQuery,
  useSetUserCredentialMutation,
  useListMyCredentialsQuery,
} = generalSettingsApi;
